import react from 'react';
import { Dropdown, Button, Space } from 'antd';

function DropdownMenu({ items, children }) {
    const menuItems = items.map(item => ({
        key: item.text,
        label: item.text,
        onClick: item.callback,
    }));

    return (
        <Dropdown menu={{ items: menuItems }} placement="bottomCenter">
            <Button>{children}</Button>
        </Dropdown>
    );
}

export default DropdownMenu